import { Pipe, PipeTransform, inject } from '@angular/core'
import { Maybe, StorageMovementType } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'
import { CreateStorageMovementType } from '../../components/palantir/palantir-select-create-storage-movement-type/palantir-select-create-storage-movement-type.component'

@Pipe({
    name: 'translateStorageMovementType',
    standalone: false
})
export class TranslateStorageMovementTypePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(value?: Maybe<CreateStorageMovementType | StorageMovementType>): string {
    return this.translateService.instant(`TRANSLATE_STORAGE_MOVEMENT_TYPE.${constantCase(String(value))}`)
  }
}
